module.exports = __webpack_public_path__ + "static/media/background-2-960w.6fce80c4.jpg";